import { useEffect } from "react"

const DatalayerTrial = ({ productName, trialDuration }) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "view_trial_start",
        trial_step: "step_1",
        product_name: productName || "",
        trial_duration_days: trialDuration,
        trial_stage: "entry",
        product_trials: {
          step: 1,
          event: "view_trial_start",
          trial_status: "not_started",
          product: productName || ""
        }
      })
    }
  }, [productName, trialDuration])

  return null
}


export function triggerTrialStarted(productName = "", trialDuration, trialStatus ) {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || []
    

    const existingEventIndex = window.dataLayer.findIndex(item => item.event === "trial_started")
    
    const updatedEvent = {
      event: "trial_started",
      trial_step: "2",
      product_name: productName,
      trial_days_remaining: trialDuration,
      trial_status: "active",
      trial_stage: "confirmed",
      product_trials: {
        step: 2,
        event: "trial_started",
        trial_days_remaining: trialDuration,
        product: productName || "",
        trial_status: trialStatus || ""
      }
    }
    
    if (existingEventIndex !== -1) {
      // Update existing event
      window.dataLayer[existingEventIndex] = updatedEvent
    } else {
      // Push new event if none exists
      window.dataLayer.push(updatedEvent)
    }
  }
}

export default DatalayerTrial 